import { useState, useCallback, useEffect, useRef } from 'react';
import { cloneDeep } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';

export const useToggleState = (
  selectedApplications = [],
  foundedApps = [],
  setSearch,
  setSelectedApplications,
  search,
  setIsOpen,
) => {
  const [state, stateSet] = useState(selectedApplications);
  const flag = useRef(true);
  const dispatch = useDispatch();

  useEffect(() => {
    stateSet(selectedApplications);
  }, [selectedApplications]);

  const isActive = useCallback(
    (pba_number) => {
      return state.find((app) => app?.pba_number === pba_number) ? true : false;
    },
    [state],
  );

  const isGlobal = useCallback(
    (pba_number) => {
      const currentApp = state.find((app) => app.pba_number === pba_number);
      return currentApp?.isGlobal;
    },
    [state],
  );

  const deleteItem = (pba_number) => {
    let newItems = cloneDeep(state);
    newItems = newItems.filter((app) => app?.pba_number !== pba_number);
    stateSet(newItems);
    flag.current = false;
  };

  const findItem = (pba_number, foundedApps) => {
    return foundedApps?.concat(state).find((app) => app?.pba_number === pba_number);
  };

  const addItem = (obj) => {
    let newItems = cloneDeep(state);
    newItems = newItems.concat({ ...obj, selected: true });
    stateSet(newItems);
    flag.current = false;
  };

  const toggle = useCallback(
    (checked, pba_number) => {
      return isActive(pba_number)
        ? deleteItem(pba_number)
        : addItem(findItem(pba_number, foundedApps));
    },
    [isActive, foundedApps],
  );

  const handleSaveSelectedApps = useCallback(() => {
    setSelectedApplications(state);
    setIsOpen(false);
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    flag.current = true;
  }, [state]);

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const itemsToShow = useCallback(() => {
    if (!search) return state;
    if (search) return foundedApps ? foundedApps : [];
  }, [foundedApps, search]);

  const restore = useCallback(() => {
    stateSet(selectedApplications);
    flag.current = true;
  }, [selectedApplications]);

  return {
    state,
    isActive,
    toggle,
    handleSaveSelectedApps,
    handleSearchOnChange,
    handleClearSearchValue,
    itemsToShow,
    restore,
    flag,
    isGlobal,
  };
};
